module.exports = flarum.core.compat['states/ComposerState'];